import React, { useState } from 'react';
import {WbEventHandlerMixins} from '../../../utils/common';
import ImgIconComp from '../../../components/imgcomp';
import PersonInp from './person-kr';
import SurveyYesNo from './yes-no';
import KrCommentEditor from './editor-container';
import ConfidenceKRPopup from '../../kr_confidence/confidence-popup.component';
import ConfidenceHoverBefore from "../../common/confidenceHoverBefore.component";
import ScaleRange from "../../../okr/modals/kr_update/scale-range";
import { KeyDownEvent, KeyDownEventLink } from '../../../utils/eventKey';
import { useTranslation } from 'react-i18next';
import { useUpdateModalActions, KrUpdateConfidenceSelect, KrUpdateNarrativeInput } from '@workboard/ui-okr';
import { useKrUpdateValidation } from '../../../resources/krUpdateValidationProvider';
import { krdetailConstants } from '../../../constants/krdetails.constants';
import ConfidenceFlag from "../../common/confidenceFlag.component";

const confidenceType = (metricType) => {
    return metricType == 1 ? 'Low confidence' : metricType == 2 ? "Medium confidence" : metricType == 3 ? "High confidence" : "";

}

const UpdateKRViewComp = React.memo((props) => {
    const {metrics=[]} = props;
    const [showDropDown,setDropdown] = useState('');
    const [showPopUpValue, setPopUpValue] = useState('');
    const [something,setSomething] = useState(false);
    const { t } = useTranslation();
    const { open: openUpdateModal } = useUpdateModalActions();
    const { getError, clearErrors } = useKrUpdateValidation();
    const openKrUpdateModal = (mItem) => {
		openUpdateModal({ krId: mItem?.id, source: mItem?.source });
	};
    const { isConfidenceOnKrUpdatesEnabled = false } = window.wbConfig ?? {};
    const showNewKrUpdateUX = (mItem) => isConfidenceOnKrUpdatesEnabled && mItem?.source == krdetailConstants.SOURCE_PERSON;

    if (!metrics.length)
        return null;

    function openConfidencePopUp(mItemId){
        setDropdown(mItemId);
    }

    function openFlagPopUp(mItemId, confidence){
        if(confidence != 0)
        setPopUpValue(mItemId);
    }

    function closeFlagPopUp() {
        setPopUpValue('');
    }

    function closeConfidencePopUp(){
        if (showDropDown !== '') {
            setDropdown('');
            $(`#confIt-${showDropDown}`).focus();
        }
    }

    function onSaveConf(){
        setSomething(!something);
    }

    function constructMetricName(m) {
        const n = (typeof m.krQuarterName !== 'undefined') ? `${m.krQuarterName}: ` : '';
        return `${n}${m.name}`;
    }
    return (
        <table aria-labelledby={props.labelledBy}>
            <thead>
                <tr>
                    <th className="ukr-data-row-kr">
                    {t('Key Result')}
                    </th>
                    <th className="ukr-data-row-metric">
                        {t('Metric')}
                    </th>
                    <th className="ukr-data-row-confidence">
                        {t('Confidence')}
                    </th>
                    <th className="ukr-data-row-date">
                        {t('Date')}
                    </th>
                    <th className="ukr-data-row-update">
                        {t('Update Value')}
                    </th>
                    <th className="ukr-data-row-comment">
                        {t('Narrative')}
                    </th>
                </tr>
            </thead>
            <tbody>
            {
                metrics.map((mItem, mIndex) => (
                <React.Fragment key={`update-kr-view-comp-${mItem.id}`}>
                        <tr>
                            <td className="ukr-data-row-kr updateKRMetricName">
                                <div className="clickable"
                                    role="link"
                                    tabIndex={0}
                                    onClick={() => props.goalDetPage(mItem.goal_id, mItem.id, true, mItem.parentMId)}
                                    onKeyDown={(e) =>{ KeyDownEventLink(e, () => props.goalDetPage(mItem.goal_id, mItem.id, true, mItem.parentMId))}}
                                    data-testid="key-results-updateKR-due"
                                >
                                    <input type="hidden" name={`metric[${mItem.id}]`} value={mItem.id} />
                                    <div id={`confKRMetricName-${mItem.id}`} className="updateKRMetricNameText">
                                {constructMetricName(mItem)}
                                    </div>
                                </div>
                            </td>
                            <td className="ukr-data-row-metric updateKRAchievedValDiv">
                                <div className="updateKRAchievedVal">
                                    <span style={{ color: mItem.progress_color, fontSize:'18px', fontWeight: 'bold' }}>{mItem.achieve_target}</span>
                                    <span className="metric-text"> {t('of')} </span>
                                    <span className="metric-text">{mItem.total_target}</span>
                                    <span style={{padding: '0 8px', verticalAlign: 'middle'}}>
                                        <ConfidenceFlag
                                            type={ mItem.confidence.confidence}
                                            cDate={mItem.confidence.created_at_formatted}
                                            uName={mItem.confidence.added_by_name}
                                            comment={mItem.confidence.comment}
                                            classProp={'krDetail'}
                                            id={mItem.id}
                                            label={`${confidenceType(mItem.confidence.confidence)} . As of ${mItem.confidence.created_at_formatted} . ${mItem.confidence.added_by_name} ${mItem.confidence.comment}`}
                                        />
                                    </span>
                                </div>
                                <div className="updateKRUpdateType">
                                    {mItem.progress_type_text}
                                </div>
                            </td>
                            { props.displayKRConfidence && (
                            <td className="ukr-data-row-confidence confidenceWrapper show-confidence-popup">
                                {
                                    
                                    showNewKrUpdateUX(mItem) ? (
                                        <KrUpdateConfidenceSelect
                                            id={`confIt-${mItem.id}`}
                                            name={`metric[${mItem.id}][${mItem.metricLastData.id}][confidence]`}
                                            defaultValue="-1"
                                        />
                                    ) : (
                                        <>
                                            <div id={`confIt-${mItem.id}`}
                                                className={mItem.confidence && Object.keys(mItem.confidence).length ?
                                                (showDropDown === mItem.id ? `confidence-clicked confidenceIcon confidenceIcon-${mItem.confidence.confidenceLabel}`
                                                :`confidenceIcon confidenceIcon-${mItem.confidence.confidence == 0 ? 'Default-Update-kr' : mItem.confidence.confidenceLabel}`)
                                                : (showDropDown === mItem.id ?'confidence-clicked confidenceIcon confidenceIcon-Default-Update-kr'
                                                :'confidenceIcon confidenceIcon-Default-Update-kr')}
                                                onClick={()=>openConfidencePopUp(mItem.id)}
                                                onFocus={()=>openFlagPopUp(mItem.id,mItem.confidence.confidence)}
                                                onBlur={() => closeFlagPopUp()}
                                                onMouseEnter={()=>openFlagPopUp(mItem.id,mItem.confidence.confidence)}
                                                onMouseLeave={() => closeFlagPopUp()}
                                                aria-label={((Object.keys(mItem.confidence).length !== 0 && mItem.confidence.confidenceLabel) ?
                                                    `${mItem.confidence.confidenceLabel} confidence
                                                    . As of ${mItem.confidence.created_at_formatted} . ${mItem.confidence.added_by_name} ${mItem.confidence.comment}` : "Confidence Rating" )
                                                }
                                                tabIndex={0}
                                                role='button'
                                                onKeyDown={(e) =>{ KeyDownEvent(e, () => openConfidencePopUp(mItem.id))}}
                                                style={{width: '28px', height: '28px', position: 'relative', left:'30px'}}>
                                            {
                                            ((showPopUpValue == mItem.id && showDropDown !== mItem.id && mItem.confidence && mItem.confidence.length !==0) || props.comingFromTest ) &&
                                                <ConfidenceHoverBefore
                                                    type={mItem.confidence.confidence}
                                                    cDate={mItem.confidence.created_at_formatted}
                                                    uName={mItem.confidence.added_by_name}
                                                    comment={mItem.confidence.comment}
                                                    id={mItem.id}
                                                    classProp={'krDetail'}
                                                />
                                            }
                                            </div>
                                            {
                                            (showDropDown === mItem.id || props.comingFromTest) &&
                                                <ConfidenceKRPopup
                                                    open={showDropDown == mItem.id}
                                                    close={closeConfidencePopUp}
                                                    confidence = {mItem.confidence}
                                                    metricId={mItem.id}
                                                    headerTitle = {true}
                                                    onSaveConf={onSaveConf}
                                                />
                                            }
                                        </>
                                    )
                                }
                            </td>
                            )}
                            {(
                                <td className="ukr-data-row-date">
                                    {mItem.metricLastData.create_at_text}
                                </td>
                            )}
                            {(props.getAllOkrs == 0)
                                && (
                                    <td className="ukr-data-row-update">
                                        {
                                            (mItem.source == "1" || (mItem.source == "5" && mItem.counting != "6" && mItem.counting != "5"))
                                            && (
                                                <div className="updateKRPersonInp">
                                                    <PersonInp
                                                        key={`person-inp-${mItem.metricLastData.id}`}
                                                        placeholderText={mItem.metric_format}
                                                        dispDate={mItem.metricLastData.create_at_text}
                                                        metricId={mItem.id}
                                                        metricDataId={mItem.metricLastData.id}
                                                    />
                                                </div>
                                            )
                                        }
                                        {
                                            mItem.source == "5" && mItem.counting == "6"
                                            && (
                                                <div className="updateKRSurveyScaleDiv">
                                                    <ScaleRange
                                                        min={mItem.lower_limit}
                                                        max={mItem.upper_limit}
                                                        value={mItem.metricLastData.m_data == '' ? 0 : mItem.metricLastData.m_data}
                                                        key={`scale-${mItem.metricLastData.id}`}
                                                        dispDate={mItem.metricLastData.create_at_text}
                                                        metricId={mItem.id}
                                                        metricDataId={mItem.metricLastData.id}
                                                    />
                                                </div>
                                            )
                                        }
                                        {
                                            mItem.source == "5" && mItem.counting == "5"
                                            && (
                                                <div className="updateKRSurveyYNDiv">
                                                    <SurveyYesNo
                                                        key={`yesno-${mItem.metricLastData.id}`}
                                                        dispDate={mItem.metricLastData.create_at_text}
                                                        metricId={mItem.id}
                                                        metricDataId={mItem.metricLastData.id}
                                                    />
                                                </div>
                                            )
                                        }
                                    </td>
                                )
                            }

                            {(props.getAllOkrs == 1)
                                && (
                                    <td className="ukr-data-row-date updateKRLastDateDiv">
                                        <div className="updateKRLastDate">
                                            {`${t('As of')} ${mItem.as_of_now}`}
                                        </div>
                                    </td>
                                )
                            }
                            {(props.getAllOkrs == 0)
                                && (
                                    <td className="ukr-data-row-comment">
                                        <div className="updateKRFullPopupEditor">
                                            {
                                              isConfidenceOnKrUpdatesEnabled ?  
                                                (
                                                    <>
                                                        <KrUpdateNarrativeInput
                                                            id={`updateKRCommentEditor_${mItem.metricLastData.id}`}
                                                            name={`metric[${mItem.id}][${mItem.metricLastData.id}][cmt]`}
                                                            defaultValue={(mItem.metricLastData && mItem.metricLastData.comment) ? mItem.metricLastData.comment.comment : ''}
                                                            error={getError({
                                                                field: 'cmt',
                                                                updateId: mItem.metricLastData.id
                                                            })}
                                                            onChange={(value, mentions) => {
                                                                if(value?.trim()) clearErrors([{
                                                                    field: 'cmt',
                                                                    updateId: mItem.metricLastData.id
                                                                }])
                                                                
                                                                const mentionUserId = mentions?.map(mention => mention.id).join(',');
                                                                $(`#updateKRCommentEditor_mentions_${mItem.metricLastData.id}`).val(mentionUserId || '');
                                                            }}
                                                        />
                                                        <input
                                                            type="hidden"
                                                            id={`updateKRCommentEditor_mentions_${mItem.metricLastData.id}`}
                                                            name={`metric[${mItem.id}][${mItem.metricLastData.id}][mentionUserId]`}
                                                        />
                                                    </>
                                                ) : (
                                                    <KrCommentEditor
                                                        key={`kr-comment-editor-${mItem.id}`}
                                                        metricId={mItem.id}
                                                        metricDataId={mItem.metricLastData.id}
                                                        showEmoticonList={props.showEmoticonList}
                                                        hideEmoticonList={props.hideEmoticonList}
                                                        selMdId={props.selMdId}
                                                        showEmoticon={props.showEmoticon}
                                                        handEmoji={props.handEmoji}
                                                        symbolEmoji={props.symbolEmoji}
                                                        pplEmoji={props.pplEmoji}
                                                        placeholder={t("Enter an optional narrative to provide details for this update")}
                                                        metricDataComment={(mItem.metricLastData && mItem.metricLastData.comment) ? mItem.metricLastData.comment.comment : ''}
                                                    />
                                                )
                                            }
                                        </div>
                                        <div
                                        role="button" tabIndex={0}
                                        className="updateKRPopupLink clickable updateKRFullPopupLink"
                                        onClick={() => showNewKrUpdateUX(mItem) ? openKrUpdateModal(mItem) : WbEventHandlerMixins.openMetricUpdatePopup(mItem.id, mItem.parentMId, 'DUE_KR')}
                                        onKeyDown={(e) =>{ KeyDownEvent(e, () => showNewKrUpdateUX(mItem) ? openKrUpdateModal(mItem) : WbEventHandlerMixins.openMetricUpdatePopup(mItem.id, mItem.parentMId, 'DUE_KR'))}}
                                        aria-describedby={`confKRMetricName-${mItem.id}`}
                                    >
                                        <ImgIconComp id="expand_img" width="15" height="15"
                                            alt={t("Open Update Dialog")}
                                        />
                                    </div>
                                    </td>
                                )
                            }
                            {(props.getAllOkrs == 1)
                                && (
                                    <td className="ukr-data-row-comment updateKRPopupLink clickable"
                                        onClick={() => showNewKrUpdateUX(mItem) ? openKrUpdateModal(mItem) : WbEventHandlerMixins.openMetricUpdatePopup(mItem.id, mItem.parentMId, 'DUE_KR')}>
                                        <ImgIconComp id="expand_img" width="12" height="12" />
                                    </td>
                                )
                            }
                        </tr>
                </React.Fragment>
            ))
            }
            </tbody>
        </table>
    )
});

export default UpdateKRViewComp;